import React from 'react';
import Spinner from './Spinner';

const ProductForm = ({
    urlInput,
    setUrlInput,
    handleSubmit,
    isLoading,
    user
}) => {
    return (
        <form onSubmit={handleSubmit} className="formulario-container formulario-centrado formulario-card">
            <h3 className="formulario-heading">
                {user ? "Añade un nuevo producto" : "Empieza en segundos"}
            </h3>
            <p className="formulario-subheading">
                {user
                    ? "Pega la URL del artículo de Amazon que quieras monitorizar y te avisaremos cuando baje de precio."
                    : "Añade tu correo y la URL del producto para recibir alertas personalizadas."}
            </p>

            <div className="formulario-group">
                <label htmlFor="product-url">
                    URL del producto ({" "}
                    <a target="_blank" rel="noreferrer" href="./avisamesibaja.mp4">
                        ver cómo obtenerla
                    </a>
                    )
                </label>
                <input
                    id="product-url"
                    type="url"
                    required
                    value={urlInput}
                    onChange={(e) => setUrlInput(e.target.value)}
                    className="formulario-input"
                    placeholder="https://www.amazon.es/dp/XXXXXX"
                />
                <p className="formulario-ayuda">
                    ¿Prefieres no copiar enlaces?{" "}
                    <a href="/boton-navegador">Añade el botón a tu navegador</a> y hazlo
                    de un clic desde Amazon.
                </p>
            </div>

            <button type="submit" disabled={isLoading} className="formulario-button">
                {isLoading ? (
                    <>
                        <Spinner size={16} />
                        Procesando...
                    </>
                ) : (
                    user ? "Guardar alerta" : "Crear alerta"
                )}
            </button>

            {!user && (
                <p className="formulario-mensaje-email">
                    📩 Recibirás un email con un enlace para iniciar sesión. Deberás hacer clic en él para acceder y activar la alerta.
                </p>
            )}
        </form>
    );
};

export default ProductForm;
